import styled, { createGlobalStyle } from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
const [mobileWidth] = breakpoints;
const maxMobileWidth = mobileWidth - 1;
export const GlobalHack = createGlobalStyle `
  body [data-testid="mobile-burger-menu-overlay"] {
    @media screen and (max-width: ${maxMobileWidth}px) {
      height: calc(100vh - 105px);
      top: 105px;
    }
}
`;
export const StyledBannerContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${maxMobileWidth}px) {
    justify-content: space-between;
    align-items: baseline;
  }

  background: ${({ theme, variant, styleOverrides }) => {
    if (typeof styleOverrides?.background !== 'undefined') {
        return styleOverrides?.background;
    }
    return variant === 'primary'
        ? theme.ColorBrandPrimary
        : theme.ColorBrandSecondary;
}};
  color: ${({ theme, styleOverrides }) => {
    if (typeof styleOverrides?.color !== 'undefined') {
        return styleOverrides?.color;
    }
    return theme.ColorWhiteOpacity100;
}};

  padding: 16px 0px;
  gap: 48px;

  @media screen and (max-width: ${maxMobileWidth}px) {
    padding: 12px 16px;
    gap: auto;
  }

  &.unmounted {
    transform: translate(0, -100%);
  }

  transition: transform 1.5s ease-in-out 1s;
`;
export const StyledTextContainer = styled.div `
  display: flex;
  gap: 4px;
  align-items: baseline;
  margin: auto 0;
  flex-direction: column;

  @media screen and (min-width: ${maxMobileWidth}px) {
    flex-direction: row;
  }
`;
export const StyledSaleName = styled.p `
  font-family: ${({ theme }) => theme.FontTextText400BoldFontFamily};
  font-size: ${({ theme }) => theme.FontTextText400BoldFontSize}px;
  font-weight: ${({ theme }) => theme.FontTextText400BoldFontWeight};
  line-height: ${({ theme }) => theme.FontTextText400BoldLineHeight}px;
  margin: 0;

  @media screen and (max-width: ${maxMobileWidth}px) {
    font-family: ${({ theme }) => theme.FontTextText300BoldFontFamily};
    font-size: ${({ theme }) => theme.FontTextText300BoldFontSize}px;
    font-weight: ${({ theme }) => theme.FontTextText300BoldFontWeight};
    line-height: ${({ theme }) => theme.FontTextText300BoldLineHeight}px;
  }
`;
export const StyledSubText = styled.p `
  font-family: ${({ theme }) => theme.FontTextText200FontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 10px;
  margin: 0;
  padding-bottom: 8px;

  @media screen and (min-width: ${maxMobileWidth}px) {
    line-height: 20px;
    padding-bottom: 0;
  }
`;
export const StyledCountdownContainer = styled.div `
  display: flex;
  gap: 8px;

  @media screen and (max-width: ${maxMobileWidth}px) {
    align-items: baseline;
  }
`;
export const StyledTimeContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const StyledNumbers = styled.p `
  text-align: center;
  font-family: ${({ theme }) => theme.FontTextText300BoldFontFamily};
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  margin: 0;

  @media screen and (max-width: ${maxMobileWidth}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;
export const StyledCountdownText = styled.p `
  text-align: center;
  font-family: ${({ theme }) => theme.FontTextText100FontFamily};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin: 0;

  @media screen and (max-width: ${maxMobileWidth}px) {
    font-size: 10px;
    line-height: 16px;
  }
`;
//# sourceMappingURL=countdown-banner.styles.js.map